import { render, staticRenderFns } from "./BaseFormButton.vue?vue&type=template&id=e321824c&"
import script from "./BaseFormButton.vue?vue&type=script&lang=js&"
export * from "./BaseFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports